export default __webpack_public_path__ + "static/media/company3.5d719911.png";